import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {useEffect, useState} from "react";
import {ExpForm} from "./ExpForm";
import {message} from "antd";

export const ExpIndex = ({onChange}) => {
    const [expForms, setExpForms] = useState([]);
    useEffect(() => {
        onChange(expForms);
    }, [expForms]);

    const addExp = () => {
        if( expForms.length < 3 ) {
            setExpForms([...expForms, {id: Date.now()}]);
        }else{
            message.error("Chỉ được thêm tối đa 3 kinh nghiệm làm việc");
        }
    }
    const removeExp = (id) => {
        setExpForms(expForms.filter(exp => exp.id !== id));
    }
    return (
        <div className={"border rounded-lg p-4 shadow-md w-full"}>
            <div className={"justify-between items-center flex"}>
                <h2 className={"text-lg font-semibold"}>Kinh nghiệm làm việc</h2>
                <button className={"text-gray-700"} onClick={addExp} >
                    <FontAwesomeIcon icon={faPlus} className={"me-2"} /> Thêm kinh nghiệp
                </button>
            </div>
            <div className={"grid grid-cols-1 gap-4 mt-4"}>
                {expForms.map((exp) => (
                    <ExpForm key={exp.id} id={exp.id} onRemove={removeExp} />
                ))}
            </div>
        </div>
    )
}